// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
console.log('Vite ⚡️ Rails');

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails');

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'

// app / javascript / packs / application.js;
import 'trix';
import '@rails/actiontext';

import './reading_mode';

// custom logic for confirming a delete!
document.addEventListener('click', function (event) {
  const el = event.target.closest('[data-confirm]');
  if (!el) return;

  const message = el.getAttribute('data-confirm');
  if (message && !confirm(message)) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
});

// Share button trigger logic
document.addEventListener('click', function (event) {
  const shareBtn = event.target.closest('[data-share-url]');
  if (!shareBtn) return;

  event.preventDefault();

  const title = shareBtn.getAttribute('data-share-title') || document.title;
  const text = shareBtn.getAttribute('data-share-text') || '';
  const url = shareBtn.getAttribute('data-share-url') || window.location.href;
  const imageUrl = shareBtn.getAttribute('data-share-image') || '';

  // Always launch premium custom share modal
  createAndShowShareModal(title, text, url, imageUrl);
});

function createAndShowShareModal(title, text, url, imageUrl) {
  // Check if modal already exists
  if (document.getElementById('techtotz-share-modal')) return;

  // Create overlay container
  const modalOverlay = document.createElement('div');
  modalOverlay.id = 'techtotz-share-modal';
  modalOverlay.className = 'fixed inset-0 z-50 flex items-center justify-center bg-paper/85 transition-opacity duration-300 opacity-0';

  // Preview card elements
  const imageMarkup = imageUrl 
    ? `<img src="${imageUrl}" class="w-full h-32 object-cover rounded-md border-2 border-ink mb-4" alt="Preview" />` 
    : '';

  const nativeShareMarkup = navigator.share 
    ? `
          <!-- More Options (Native Share) -->
          <button id="share-native" class="col-span-2 flex items-center justify-center space-x-2 py-3 rounded-md bg-blue/20 hover:bg-blue/35 text-blue text-xs font-bold transition-all border-2 border-blue cursor-pointer">
            <span>📤</span>
            <span>More Options</span>
          </button>
    ` 
    : '';

  // Modal content structure (Bioluminescent Glassmorphism card)
  modalOverlay.innerHTML = `
    <div class="relative bg-paper-shade/95 border-2 border-blue rounded-md p-6 max-w-md w-full mx-4 transform transition-all duration-300 scale-95 opacity-0 select-none">
      
      <!-- Close Button -->
      <button id="close-share-modal" class="absolute top-4 right-4 text-ink-soft hover:text-pink transition-colors cursor-pointer focus:outline-none">
        <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>

      <div class="space-y-4">
        <div>
          <span class="text-[10px] font-extrabold uppercase tracking-wider text-blue">Jungle Connection</span>
          <h3 class="text-xl font-extrabold text-ink">Share this Quest</h3>
        </div>

        <!-- Preview Card -->
        <div class="bg-paper/50 border-2 border-ink rounded-md p-4">
          ${imageMarkup}
          <h4 class="text-sm font-bold text-ink line-clamp-1">${title}</h4>
          <p class="text-xs text-ink-soft line-clamp-2 mt-1">${text}</p>
          <span class="text-[10px] text-ink-mute font-mono block mt-2">${url}</span>
        </div>

        <!-- Share Actions Grid -->
        <div class="grid grid-cols-2 gap-3 pt-2">
          <!-- Facebook -->
          <a href="https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}" target="_blank" rel="noopener" class="flex items-center justify-center space-x-2 py-3 rounded-md bg-blue-600 hover:bg-blue-700 text-white text-xs font-bold transition-all">
            <span>🔵</span>
            <span>Facebook</span>
          </a>

          <!-- Copy Link -->
          <button id="copy-share-link" class="flex items-center justify-center space-x-2 py-3 rounded-md bg-paper-shade hover:bg-ink-soft text-ink text-xs font-bold transition-all border-2 border-ink cursor-pointer">
            <span>🔗</span>
            <span>Copy Link</span>
          </button>

          <!-- Instagram (Helper) -->
          <button id="share-instagram" class="col-span-1 flex items-center justify-center space-x-2 py-3 rounded-md bg-gradient-to-tr from-yellow-500 via-pink-500 to-purple-600 hover:opacity-90 text-white text-xs font-bold transition-all cursor-pointer">
            <span>📸</span>
            <span>Instagram</span>
          </button>

          <!-- TikTok (Helper) -->
          <button id="share-tiktok" class="col-span-1 flex items-center justify-center space-x-2 py-3 rounded-md bg-black hover:bg-paper-shade text-white text-xs font-bold transition-all border-2 border-ink cursor-pointer">
            <span>🎵</span>
            <span>TikTok</span>
          </button>

          ${nativeShareMarkup}
        </div>

        <!-- Helper Prompt text -->
        <p id="share-prompt-msg" class="text-[10px] text-ink-soft text-center font-medium min-h-[16px] transition-all duration-300"></p>
      </div>
    </div>
  `;

  document.body.appendChild(modalOverlay);

  // Trigger animations
  setTimeout(() => {
    modalOverlay.classList.remove('opacity-0');
    modalOverlay.querySelector('.relative').classList.remove('scale-95', 'opacity-0');
  }, 10);

  // Close modal helper
  const closeModal = () => {
    modalOverlay.classList.add('opacity-0');
    modalOverlay.querySelector('.relative').classList.add('scale-95', 'opacity-0');
    setTimeout(() => {
      modalOverlay.remove();
    }, 300);
  };

  // Attach event listeners
  modalOverlay.querySelector('#close-share-modal').addEventListener('click', closeModal);
  modalOverlay.addEventListener('click', (e) => {
    if (e.target === modalOverlay) closeModal();
  });

  const promptMsg = modalOverlay.querySelector('#share-prompt-msg');

  // Copy Link action
  modalOverlay.querySelector('#copy-share-link').addEventListener('click', async () => {
    try {
      await navigator.clipboard.writeText(url);
      promptMsg.textContent = 'Link copied to clipboard! 📋';
      promptMsg.className = 'text-[10px] text-blue text-center font-bold min-h-[16px]';
    } catch (err) {
      promptMsg.textContent = 'Failed to copy link.';
      promptMsg.className = 'text-[10px] text-error-red text-center font-bold min-h-[16px]';
    }
  });

  // Instagram click helper
  modalOverlay.querySelector('#share-instagram').addEventListener('click', async () => {
    try {
      await navigator.clipboard.writeText(url);
      promptMsg.textContent = 'Link copied! Open Instagram to share. 📸';
      promptMsg.className = 'text-[10px] text-pink text-center font-bold min-h-[16px]';
    } catch (err) {
      promptMsg.textContent = 'Open Instagram on mobile to share.';
    }
  });

  // TikTok click helper
  modalOverlay.querySelector('#share-tiktok').addEventListener('click', async () => {
    try {
      await navigator.clipboard.writeText(url);
      promptMsg.textContent = 'Link copied! Open TikTok to share. 🎵';
      promptMsg.className = 'text-[10px] text-violet text-center font-bold min-h-[16px]';
    } catch (err) {
      promptMsg.textContent = 'Open TikTok on mobile to share.';
    }
  });

  // Native share action if supported
  if (navigator.share) {
    const nativeBtn = modalOverlay.querySelector('#share-native');
    if (nativeBtn) {
      nativeBtn.addEventListener('click', async () => {
        try {
          await navigator.share({
            title: title,
            text: text,
            url: url
          });
          closeModal();
        } catch (err) {
          if (err.name !== 'AbortError') {
            console.error('Web Share failed:', err);
            promptMsg.textContent = 'Failed to share natively.';
            promptMsg.className = 'text-[10px] text-error-red text-center font-bold min-h-[16px]';
          }
        }
      });
    }
  }
}
